import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import GlobalStyle from './styles/globalStyle';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/dist/ScrollTrigger';
import {ScrollSmoother} from 'gsap/dist/ScrollSmoother';
import {SmootherContext} from './components/nzuac-helpers/SmootherContext';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from 'react-redux';
import {apiEndPoints} from './api/network/apiEndPoints';
import {fetchPostsChildFilter, fetchPostsSettings} from './api/redux/home';
import {AnimatePresence} from 'framer-motion';
// import {Loading} from './components/nzuac-preload/Loading';
import RouterMain from './router/RouterMain';
import PageLoaderNew from './components/nzuac-preload/PageLoaderNew';
import MainFooter from './global/MainFooter';
import SignUpButton from './components/nzuac-buttons/SignUpButton';
import MessengerButton from './components/nzuac-buttons/MessengerButton';
import MainMenu from './global/MainMenu';
import {SplitUp} from './components/nzuic-animations/TextAnimation';
import {ImageReveal} from './components/nzuic-animations/imageReveal';
import MobileMenuNew from './global/parts/MobileMenuNew';
import {Loading} from './components/nzuac-preload/Loading';
import OpeningModal from './components/nzuac-section/OpeningModal';
import { useFacebookPixelPageTracking } from './hooks/useFacebookPixel';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
function App() {
  const location = useLocation();
  const main = useRef();
  const smoother = useRef();
  // smooth scroll
  const useIsomorphicLayoutEffect = typeof window !== 'undefined'
    ? useLayoutEffect
    : useEffect;
  // api call
  const dispatch = useDispatch();

  useEffect(() => {
    let api_filter = apiEndPoints.FILTER;
    dispatch(fetchPostsChildFilter([api_filter]));
    let api_settings = apiEndPoints.SETTINGS;
    dispatch(fetchPostsSettings([api_settings]));
  }, [dispatch, location]);

  let getPost = useSelector(state => state.home);
  let filter = getPost?.filter?.filter;
  let settingsData = getPost?.settings?.data;

  // smooth scroll

  useIsomorphicLayoutEffect(() => {

    const isMobile = window?.innerWidth < 992;
    const body = document.querySelector('body');
    const html = document.querySelector('html');



    const ctx = gsap.context(() => {
      if (!ScrollTrigger.isTouch) {
        smoother.current = ScrollSmoother.create({
          wrapper: '#smooth-wrapper',
          content: '#smooth-content',
          smooth: !isMobile ? 3 : 2,
          effects: isMobile ? false : true,
          normalizeScroll: {

            allowNestedScroll: isMobile ? false : true,

          },
          ignoreMobileResize: isMobile ? false : true,

          preventDefault: true,
        }, main);
      }

    }, main);

    if (location.hash) {
      setTimeout(() => {

        if(!isMobile){
          smoother.current.scrollTo(location.hash, 3);
        }else{
          window.scrollTo(0, document.querySelector(location.hash)?.offsetTop || 0); // Fallback
        }
        if (body.classList.contains('scroll-down')) {
          body.classList.remove('scroll-down');
        }

        if (body.classList.contains('scroll-up')) {
          body.classList.remove('scroll-up');
        }


        if (body.classList.contains('stop-scroll')) {
          body.classList.remove('stop-scroll');
        }

        if (html.classList.contains('menu-is-open')) {
          html.classList.remove('menu-is-open');
        }

        if (body.classList.contains('menu-is-open')) {
          body.classList.remove('menu-is-open');
        }

      }, 500);

    }
    ScrollTrigger.refresh();

    return () => {

      if(smoother.current){
        ctx.revert(); // Properly destroy the smoother instance
        smoother.current = null;

      }
      ScrollTrigger.clearMatchMedia(); // Clear responsive ScrollTrigger setups
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill()); // Remove all active ScrollTriggers

    };

  }, [location.pathname, location.hash]);







  useEffect(() => {
    const currentUrl = window.location.origin + location.pathname + location.search;
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = currentUrl;
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.classList.toggle('in-home-page', location.pathname === '/');
  }, [location.pathname]);
  useEffect(() => {
    // Scroll to top whenever the route changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const store = useSelector(s => s);


  useEffect(() => {
    // Use GSAP to animate opacity from 0 to 1
    gsap.to('.hide', {alpha: 1, visibility: 'visible', display: 'block', duration: 0.5, delay: 1});
    gsap.to('.pagetransition-loader', {alpha: 0, display: 'none', height: '0', duration: 0.5, delay: 1});
    gsap.to('.desktop-menu__bottom__parent-ul > li ul', {alpha: 0, duration: 0.5, delay: 1});

    // if()

    const body = document.querySelector('body');
    const applyNow = document.querySelector('.applyNow');
    const html = document.querySelector('html');

    if (body.classList.contains('scroll-down')) {
      body.classList.remove('scroll-down');
    }

    if (body.classList.contains('scroll-up')) {
      body.classList.remove('scroll-up');
    }


    if (body.classList.contains('stop-scroll')) {
      body.classList.remove('stop-scroll');
    }

    if (html.classList.contains('menu-is-open')) {
      html.classList.remove('menu-is-open');
    }

    if (body.classList.contains('menu-is-open')) {
      body.classList.remove('menu-is-open');
    }
    if ((body.classList.contains('stop-scroll')) && window.innerWidth < 992) {
      body.classList.remove('stop-scroll');
    }

    if ((applyNow) && window.innerWidth < 992) {
      applyNow.classList.remove('mobile-menu-open');
    }


    // You can customize the animation duration and other properties as needed
  }, [location.pathname]); // Run this effect only once when the component mounts

  SplitUp(store);
  ImageReveal(store);

  const [isModalOpen, setIsModalOpen] = useState(false);


  useEffect(() => {
    // Set a timeout to open the modal after 5 seconds
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 5000); // 5000 milliseconds = 5 seconds

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Track page views with Facebook Pixel
  useFacebookPixelPageTracking();

  return (
    <>


      {/* Loading components for various slices */}
      {store?.home?.loadingForm && <Loading/>}
      {store?.contact?.loadingForm && <Loading/>}



      <GlobalStyle/>
      <ToastContainer position="top-right" autoClose={4000} closeOnClick hideProgressBar={true}/>
      {window?.innerWidth > 992 ? <MainMenu filter={filter} /> : <MobileMenuNew data={settingsData}/>}

      {location?.pathname === '/' ? <PageLoaderNew data={getPost} /> : ''}


      <div className="hide">
        {/*<CallButton/>*/}

        {
          window.innerWidth > 767 &&
            <SignUpButton/>
        }
        <MessengerButton data={settingsData}/>
        {
          location?.pathname === '/' &&
            <OpeningModal show={isModalOpen} handleClose={handleCloseModal}/>
            
        }
      </div>

      <SmootherContext.Provider value={{ smoother: smoother.current, settingsData }}>
        <div className="App" ref={main} id="smooth-wrapper">

          <div id="smooth-content">
            <AnimatePresence exitBeforeEnter>
              <RouterMain key="router-main" filter={filter}/> {/* Assign a unique key */}
              <MainFooter settingsData={settingsData} key="main-footer"/> {/* Assign a unique key */}
            </AnimatePresence>
          </div>
        </div>
      </SmootherContext.Provider>
    </>


  );
}

export default App;
